const STRINGS = {
  NO_QUESTIONS_FOUND: 'No questions found',
  LOADING: 'loading...',
  LOGOUT: 'Logout',
  ENTER_NUMBER: 'Enter Number',
};

export default STRINGS;
